var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.719 3.938H3.28a.656.656 0 0 0-.656.656v11.812c0 .363.294.657.656.657H17.72a.656.656 0 0 0 .656-.657V4.594a.656.656 0 0 0-.656-.657"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m2.625 13.781 4.126-4.126a.656.656 0 0 1 .935 0l3.659 3.659a.66.66 0 0 0 .935 0l1.69-1.69a.657.657 0 0 1 .935 0l3.47 3.47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.797 9.188a.984.984 0 1 0 0-1.97.984.984 0 0 0 0 1.97"
  })));
};
export default SvgImage;